import { Box } from '@ff-it/ui';
import { Heading, SubNav, useEntity, useModel } from 'components';
import { PriceList } from 'modules/supplier/pricelist/types';
import { ReactElement } from 'react';
import { NavLinkProps } from 'react-router-dom';

export function Nav(): ReactElement {
  const model = useModel();
  const { item } = useEntity<PriceList>();

  const nav: NavLinkProps[] = [
    {
      to: '',
      end: true,
      children: 'Update',
    },
    {
      to: 'prices',
      children: 'Prices',
    },
    {
      to: 'factors',
      children: 'Factors',
    },
  ];

  return (
    <SubNav nav={nav}>
      <Heading>
        <Box textSize="sm">{model.entityTitle(item)}</Box>
      </Heading>
    </SubNav>
  );
}
